import jwtDecode from 'jwt-decode';

import store from 'src/store/configureStore';
import { USER_TYPES, DEMO_USER_ID } from 'src/constants/config';

export const isDemoUser = (decodedToken) => {
  if (!decodedToken) return false;
  return decodedToken.userType === USER_TYPES.DEMO || decodedToken.userID === DEMO_USER_ID;
};

export const isCurrentUserDemo = () => {
  try {
    const state = store.getState();
    const token = state.jwtToken?.token;

    if (!token) return false;

    const decoded = jwtDecode(token);
    return isDemoUser(decoded);
  } catch (error) {
    console.error('Error checking demo status:', error); // eslint-disable-line no-console
    return false;
  }
};
